export const htmlAllowedEmptyTags: string[] = [
  "textarea",
  "a",
  "iframe",
  "object",
  "video",
  "style",
  "script",
  ".fa",
  ".far",
  ".fao",
  ".icon",
  "p",
  "br",
  "span"
];
